import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const toggleModal = (status) => ({
  type: types.TOGGLE_MODAL,
  status,
});

export const toggleExpandedView = () => ({
  type: types.TOGGLE_EXAPANDED_VIEW,
});

export const deletePolicy = (id: number) => ({
  type: types.DELETE_POLICY,
  id,
});

export const activatePolicy = (id: number) => ({
  type: types.ACTIVATE_POLICY,
  id,
});

export const clonePolicy = (id: number) => ({
  type: types.CLONE_POLICY,
  id,
});

export const reorderPolicies = (order: number[]) => ({
  type: types.REORDER_POLICIES,
  order,
});

export const updatePolicy = (data: any) => ({
  type: types.UPDATE_POLICY,
  data,
});

export const toggleLoading = (status) => ({
  type: types.TOGGLE_LOADING,
  status,
});

export const toggleSortable = (status) => ({
  type: types.TOGGLE_SORTABLE,
  status,
});

export const setData = (data) => ({
  type: types.SET_DATA,
  data,
});

export const toggleSubmitting = (status) => ({
  type: types.TOGGLE_SUBMITTING,
  status,
});

export const setView = (view) => ({
  type: types.SET_VIEW,
  view,
});
